module.exports = __webpack_public_path__ + "static/img/template_img_02.55171589.jpg";